import React, { Component } from "react";
import "./BrandContent.scss";
import { Link } from "react-router-dom";
import BrandlistMenu from "../../../../components/Brands/BrandlistMenu/BrandlistMenu";
import { getVideosByBrand, getBrandById } from "../../../../api/brands";
import images from "../../../../ressources/images";
import BrandVideosItem from "../../../../components/Brands/BrandVideosItem/BrandVideosItem";
import { withTranslation } from "react-i18next";

export class BrandVideos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      whoActive: "videos",
      brandId: 0,
      dataVideos: [],
      dataBrand: [],
      lng: this.props.i18n.language,
      loadImage: false,
    };
  }

  UNSAFE_componentWillMount() {
    let brandId = document.location.href.split("/");
    brandId = brandId[brandId.length - 1];
    this.setState({ brandId: brandId });
  }

  componentDidMount() {
    this.getBrandByIdFront();
    this.getVideosData();
  }

  componentDidUpdate() {
    if (this.state.lng !== this.props.i18n.language) {
      this.setState({ lng: this.props.i18n.language });
      this.getBrandByIdFront();
      this.getVideosData();
    }
  }

  getBrandByIdFront = () => {
    const { brandId } = this.state;
    this.setState({ dataBrand: [] });
    getBrandById(brandId).then((data) => {
      this.setState({ dataBrand: data, loadImage: true });
    });
  };

  getVideosData = () => {
    const { brandId } = this.state;

    this.setState({ dataVideos: [] });
    getVideosByBrand(brandId).then((data) => {
      this.setState({ dataVideos: data });
    });
  };

  render() {
    const { t } = this.props;
    const { brandId, dataBrand, dataVideos, whoActive, loadImage } = this.state;
    return (
      <>
        <div className="white--wrapper">
          <Link
            className="brandlist_backlink"
            to={{ pathname: "/brands", state: { transitionName: "slide_in" } }}
          >
            <img src={images.arrow_left_black} alt="" />
          </Link>
          <div className="brandlist_content default-layout--min-height flex flex-col">
            <div className="flex-row-center">
              <div className="brand_logo">
                {loadImage && (
                  <img
                    className="brandlist_logo"
                    src={dataBrand.logoNoir}
                    alt="logo"
                  />
                )}
              </div>
            </div>
            <BrandlistMenu whoActive={whoActive} brandId={brandId} />
            <div className="brand_contentlist">
              {dataVideos.length > 0 ? (
                dataVideos.map((video, index) => (
                  <BrandVideosItem
                    key={index}
                    brandId={brandId}
                    VideoId={video.id}
                    VideoPicture={video.picture}
                    VideoTitle={video.title}
                    VideoSubtitle={video.subtitle}
                    YoutubeId={video.youtube_id}
                  />
                ))
              ) : (
                <div className="back_soon">
                  <div>{t("video_missing")}</div>
                  <div>{t("come_back_soon")} </div>
                  <span className="smile" role="img" aria-label="">
                    &#128578;
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(BrandVideos);
